import { useEffect, useState } from "react";
import { FormModalControlled } from "../../components/Modal";
import Input from "../../components/Input";

const ColorValueModal = ({ isOpen, onClose, onSave }) => {
  const [value, setValue] = useState("");
  const [labelDifferent, setLabelDifferent] = useState(false);
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setValue("");
      setLabelDifferent(false);
      setLabel("");
    }
  }, [isOpen]);

  const trimmedValue = value.trim().toUpperCase();
  const trimmedLabel = label.trim();
  const canSave = trimmedValue.length > 0 && (!labelDifferent || trimmedLabel.length > 0);

  const handleSubmit = () => {
    if (!canSave) return;
    onSave?.({
      suffix: trimmedValue,
      label: labelDifferent ? trimmedLabel : trimmedValue,
    });
    onClose?.();
  };

  return (
    <FormModalControlled
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitLabel="Gerai"
      cancelLabel="Atšaukti"
      disabled={!canSave}
    >
      <h2>Spalva. Pridėti reikšmę</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          margin: "var(--gap) 0",
          minWidth: "min(400px, 80vw)",
        }}
      >
        <Input
          label="Vertė"
          value={value}
          onChange={(e) => setValue(e.target.value.toUpperCase())}
          placeholder="pvz. SVI"
        />
        <Input
          type="checkbox"
          label="Vertė ir etiketė skirtingos"
          name="label_different"
          value={labelDifferent}
          onChange={() => setLabelDifferent((prev) => !prev)}
        />
        {labelDifferent && (
          <Input
            label="Etiketė"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="pvz. Rudas korpusas/Rudas stalčius"
          />
        )}
      </div>
    </FormModalControlled>
  );
};

export default ColorValueModal;
